import { createGlobalRoute } from '@townsquare/router/create-route';
import type { GlobalHomePageRoute } from '@townsquare/router/route-types';

export const discoverRouteDefinition: GlobalHomePageRoute = createGlobalRoute({
	exact: true,
	name: 'discover',
	path: '/discover',
	layout: 'home',
});
